const GIB = 1024 ** 3;

export interface SatelliteArchiveSizeSource {
  satellite?: {
    result?: unknown;
  } | null;
  safeOutputJson?: string | null;
}

export function formatArchiveSizeGiB(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) {
    return '—';
  }
  return `${(bytes / GIB).toFixed(2)} GiB`;
}

export function readSatelliteArchiveSizes(assignment: SatelliteArchiveSizeSource): {
  estimatedSizeInBytes: number | null;
  downloadedSizeInBytes: number | null;
} {
  const result = asRecord(assignment.satellite?.result);
  return {
    estimatedSizeInBytes:
      readByteCount(result, 'estimatedSizeInBytes')
      ?? readByteCountFromOutput(assignment.safeOutputJson, ['EstimatedSizeInBytes', 'estimatedSizeInBytes']),
    downloadedSizeInBytes:
      readByteCount(result, 'downloadedSizeInBytes')
      ?? readByteCountFromOutput(assignment.safeOutputJson, ['DownloadedSizeInBytes', 'downloadedSizeInBytes']),
  };
}

function readByteCountFromOutput(json: string | null | undefined, keys: string[]): number | null {
  if (!json) return null;
  try {
    return readByteCountFromKeys(asRecord(JSON.parse(json)), keys);
  } catch {
    return null;
  }
}

function readByteCountFromKeys(record: Record<string, unknown> | null, keys: string[]): number | null {
  if (!record) return null;
  for (const key of keys) {
    const value = readByteCount(record, key);
    if (value != null) return value;
  }
  return null;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

function readByteCount(record: Record<string, unknown> | null, key: string): number | null {
  if (!record) return null;
  const value = record[key];
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}
